import api from "./api";

// 删除agent用户知识库
export const deleteAgentUserKnowledgeFolder = async ({
  agentId,
  userId,
  type,
  folderId,
}: {
  agentId: string;
  userId: string;
  type: number;
  folderId: number;
}) => {
  const res = await api.post<unknown>("/knowledge/delete_agent_user_knowledge_folders", {
    agent_id: agentId,
    user_id: userId,
    type: type,
    folder_id: folderId,
  });
  return res;
};
